var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_135_3845)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.143 18.5714C12.5631 18.5714 13.7144 17.4202 13.7144 16C13.7144 14.5799 12.5631 13.4286 11.143 13.4286C9.7228 13.4286 8.57153 14.5799 8.57153 16C8.57153 17.4202 9.7228 18.5714 11.143 18.5714Z",
    stroke: "#5F6D79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8573 23.4285C22.2775 23.4285 23.4287 22.2772 23.4287 20.8571C23.4287 19.4369 22.2775 18.2856 20.8573 18.2856C19.4372 18.2856 18.2859 19.4369 18.2859 20.8571C18.2859 22.2772 19.4372 23.4285 20.8573 23.4285Z",
    stroke: "#5F6D79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8573 13.7143C22.2775 13.7143 23.4287 12.563 23.4287 11.1428C23.4287 9.72268 22.2775 8.57141 20.8573 8.57141C19.4372 8.57141 18.2859 9.72268 18.2859 11.1428C18.2859 12.563 19.4372 13.7143 20.8573 13.7143Z",
    stroke: "#5F6D79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4399 14.8571L18.5599 12.2856",
    stroke: "#5F6D79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.4399 17.1428L18.5599 19.7143",
    stroke: "#5F6D79",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_135_3845"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.3c16e426.svg";
export { ForwardRef as ReactComponent };